import React from 'react';
import { Box, IconButton, Stack, Typography, alpha } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// หัวข้อ modal มาตรฐาน — ไอคอนวงกลม + ชื่อเรื่อง + subtitle (ถ้ามี) + ปุ่มปิด ใช้ร่วมกันในทุก
// modal ย่อยของโมดูล Marketing (เดิมแต่ละไฟล์เขียน DialogTitle เองคนละแบบ ไม่สม่ำเสมอ) ใส่ตรงๆ
// เป็น children ของ DialogTitle (DialogTitle เดิมต้องเซ็ต sx={{ p: 0 }})
export default function ModalHeader({
  icon, title, subtitle, extra, onClose, disabled, color = 'primary',
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ px: 3, py: 2.25, borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: (theme) => alpha(theme.palette[color].main, 0.12),
          color: `${color}.main`,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="subtitle1" fontWeight={700} noWrap>{title}</Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {extra}
      {onClose && (
        <IconButton size="small" onClick={onClose} disabled={disabled}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
}
